import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Form, Input, Spin, message } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { addSuppliers } from "../../network/settings";
import {
  deleteSuppliers,
  showSuppliers,
  updateSuppliers,
} from "../../network/supplier";
import queryClient from "../../services/react-query/queryClient";
import { queryKeys } from "../../services/react-query/queryKeys";
import { checkStringInLanguage } from "../../utils/utils";

interface modalFormProps {
  close: () => void;
  setSupplierId?: (id: number) => void;
  isEdit?: any;
  id?: any;
}

const ModalForm = ({ close, setSupplierId, isEdit = 0 }: modalFormProps) => {
  const [value1, setValue1] = useState<any>();
  const [value2, setValue2] = useState<any>();
  const {
    mutate: AddSuppliers,
    isLoading,
    error: addSalonError,
  } = useMutation(addSuppliers, {
    onSuccess: (res: any) => {
      if (
        res?.response?.status === 422 ||
        res?.response?.status === 500 ||
        res?.response?.status === 404
      ) {
        message.error(res?.response?.data?.message);
      } else {
        if (setSupplierId) {
          if (res?.data?.data?.id) {
            setSupplierId(res?.data?.data?.id);
          }
        }
        message.success(intl.formatMessage({ id: "supplierAddedSuccess" }));
        queryClient.invalidateQueries([queryKeys.listSuppliers]);
        close();
      }
    },
    onError: (error: any) => {
      message.error(error?.message);
      message.error("Failed to add salon. Please try again.");
    },
  });
  const { mutate: UpdateSupp, isLoading: loadingUpdate } = useMutation(
    updateSuppliers,
    {
      onSuccess: (res: any) => {
        if (
          res?.response?.status === 422 ||
          res?.response?.status === 500 ||
          res?.response?.status === 404
        ) {
          message.error(res?.response?.data?.message);
        } else {
          if (setSupplierId) {
            if (res?.data?.data?.id) {
              setSupplierId(isEdit);
            }
          }
          message.success(intl.formatMessage({ id: "supplierUpdatedSuccess" }));
          queryClient.invalidateQueries([queryKeys.listSuppliers]);
          close();
        }
      },
    }
  );
  const { mutate: DeleteSuppliers, isLoading: loadingDelete } = useMutation(
    () => deleteSuppliers(isEdit),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.listSuppliers]);
        message.success("deleted");
        close();
      },
      onError: () => {
        message.error("try again");
      },
    }
  );
  const onFinish = (values: any) => {
    values.contact_name = {};
    values.contact_name.ar = values?.name?.ar;
    values.contact_name.en = values?.name?.en;
    console.log(values);
    isEdit ? UpdateSupp({ id: isEdit, ...values }) : AddSuppliers(values);
  };
  const { data: Supplier, isLoading: isLoadingShow } = useQuery(
    ["SupplierId", isEdit],
    () => showSuppliers(isEdit, true),
    { enabled: isEdit ? true : false }
  );
  console.log(Supplier, "545454");
  const [form] = Form.useForm();
  const intl = useIntl();
  useEffect(() => {
    queryClient.invalidateQueries(["SupplierId"]);
  });
  return (
    <div className="flex flex-col items-center justify-center w-full">
      <h4 className="mb-4 text-lg font-semibold text-color-primary">
        {isEdit
          ? intl.formatMessage({ id: "updateResourceInfo" })
          : intl.formatMessage({ id: "addSupplierButton" })}
      </h4>
      <p className="mb-8 text-[#75757E] text-sm">
        {isEdit
          ? null
          : intl.formatMessage({ id: "completeInformationToAddSupplier" })}
      </p>
      {isLoadingShow && isEdit ? (
        <Spin className="flex items-center justify-center" />
      ) : (
        <Form
          className="w-full rounded-lg"
          name="AddStocktaking"
          onFinish={onFinish}
          layout={"vertical"}
          form={form}
          initialValues={{
            name: {
              ar: Supplier?.data?.name?.ar,
              en: Supplier?.data?.name?.en,
            },
            description: {
              ar: Supplier?.data?.description?.ar,
              en: Supplier?.data?.description?.en,
            },
            contact_name: {
              ar: Supplier?.data?.contact_name?.ar,
              en: Supplier?.data?.contact_name?.en,
            },
            email: Supplier?.data?.email,
            website: Supplier?.data?.website,
            phone: Supplier?.data?.phone, // Make sure the format matches what PhoneInputWithCountrySelect expects
            mobile: Supplier?.data?.mobile, // Similarly for mobile
          }}
        >
          <div className="flex items-center gap-4 max-lg:flex-col">
            <Form.Item
              name={["name", "ar"]}
              label={intl.formatMessage({ id: "supplierNameLabelar" })}
              className="w-full"
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "supplierNameRequiredErrorMessage",
                  }),
                },
                {
                  validator: (_, value) => {
                    if (value) {
                      if (checkStringInLanguage(value, "ar")) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          new Error(
                            intl.formatMessage({
                              id: "service_name_arabic_error",
                            })
                          )
                        );
                      }
                    }
                  },
                },
              ]}
              required={false}
            >
              <Input
                placeholder={intl.formatMessage({ id: "supplierNameLabelar" })}
              />
            </Form.Item>
            <Form.Item
              name={["name", "en"]}
              label={intl.formatMessage({ id: "supplierNameLabelen" })}
              className="w-full"
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "supplierNameRequiredErrorMessage",
                  }),
                },
                {
                  validator: (_, value) => {
                    if (value) {
                      if (checkStringInLanguage(value, "en")) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          new Error(
                            intl.formatMessage({
                              id: "service_name_english_error",
                            })
                          )
                        );
                      }
                    }
                  },
                },
              ]}
              required={false}
            >
              <Input
                placeholder={intl.formatMessage({ id: "supplierNameLabelen" })}
              />
            </Form.Item>
          </div>

          <div className="flex items-center gap-4 max-lg:flex-col">
            <Form.Item
              name={["description", "ar"]}
              label={
                <div>
                  {intl.formatMessage({ id: "supplierDescriptionLabelar" })}
                  <span className="text-[10px] font-semibold mx-1 text-[#75757E]">
                    ( {intl.formatMessage({ id: "optional" })} )
                  </span>
                </div>
              }
              className="w-full"
              rules={[
                {
                  validator: (_, value) => {
                    if (value) {
                      if (checkStringInLanguage(value, "ar")) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          new Error(
                            intl.formatMessage({
                              id: "service_name_arabic_error",
                            })
                          )
                        );
                      }
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <Input.TextArea
                placeholder={intl.formatMessage({
                  id: "supplierDescriptionLabelar",
                })}
              />
            </Form.Item>
            <Form.Item
              name={["description", "en"]}
              label={
                <div>
                  {intl.formatMessage({ id: "supplierDescriptionLabelen" })}
                  <span className="text-[10px] font-semibold mx-1 text-[#75757E]">
                    ( {intl.formatMessage({ id: "optional" })} )
                  </span>
                </div>
              }
              className="w-full"
              rules={[
                {
                  validator: (_, value) => {
                    if (value) {
                      if (checkStringInLanguage(value, "en")) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          new Error(
                            intl.formatMessage({
                              id: "service_name_english_error",
                            })
                          )
                        );
                      }
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <Input.TextArea
                placeholder={intl.formatMessage({
                  id: "supplierDescriptionLabelen",
                })}
              />
            </Form.Item>
          </div>

          <div className="grid items-center bg-[#FBFBFF] p-4 rounded-lg">
            <h4 className="mb-4 text-lg font-semibold text-color-primary">
              {intl.formatMessage({ id: "contactInformationTitle" })}
            </h4>
            <div className="grid items-center justify-between grid-cols-1 gap-4 md:grid-cols-2">
              {/* <Form.Item
                name={["contact_name", "ar"]}
                label={intl.formatMessage({ id: "supplierNameLabelar" })}
                className="w-full"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "supplierNameRequiredErrorMessage",
                    }),
                  },
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (checkStringInLanguage(value, "ar")) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(
                            new Error(
                              intl.formatMessage({
                                id: "service_name_arabic_error",
                              })
                            )
                          );
                        }
                      }
                    },
                  },
                ]}
                required={false}
              >
                <Input
                  placeholder={intl.formatMessage({
                    id: "supplierNameLabelar",
                  })}
                />
              </Form.Item>
              <Form.Item
                name={["contact_name", "en"]}
                label={intl.formatMessage({ id: "supplierNameLabelen" })}
                className="w-full"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "supplierNameRequiredErrorMessage",
                    }),
                  },
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (checkStringInLanguage(value, "en")) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(
                            new Error(
                              intl.formatMessage({
                                id: "service_name_english_error",
                              })
                            )
                          );
                        }
                      }
                    },
                  },
                ]}
                required={false}
              >
                <Input
                  placeholder={intl.formatMessage({
                    id: "supplierNameLabelen",
                  })}
                />
              </Form.Item> */}
              <Form.Item
                name={"email"}
                label={intl.formatMessage({ id: "emailLabel" })}
                className="w-full"
                rules={[
                  {
                    type: "email",
                    required: true,
                    message: intl.formatMessage({
                      id: "emailRequiredErrorMessage",
                    }),
                  },
                ]}
                required={false}
              >
                <Input placeholder={intl.formatMessage({ id: "emailLabel" })} />
              </Form.Item>
              <Form.Item
                name={"website"}
                label={
                  <div>
                    {intl.formatMessage({ id: "websiteLabel" })}
                    <span className="text-[10px] font-semibold mx-1 text-[#75757E]">
                      ( {intl.formatMessage({ id: "option" })})
                    </span>
                  </div>
                }
                className="w-full"
                required={false}
              >
                <Input
                  placeholder={intl.formatMessage({ id: "websiteLabel" })}
                />
              </Form.Item>
              <Form.Item
                label={intl.formatMessage({ id: "phoneLabel" })}
                name="phone"
                required={false}
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "phoneRequiredErrorMessage",
                    }),
                  },
                ]}
                className=""
              >
                <PhoneInputWithCountrySelect
                  defaultCountry="SA"
                  value={value1}
                  onChange={setValue1}
                  limitMaxLength={true}
                  international
                  hasFeedback
                  className="!border-[1px] !border-solid !border-color-primary !py-2 !px-[11px] !h-[42px]"
                />
              </Form.Item>
              <Form.Item
                label={
                  <div>
                    {intl.formatMessage({ id: "mobileLabel" })}
                    <span className="text-[10px] font-semibold mx-1 text-[#75757E]">
                      ( {intl.formatMessage({ id: "option" })})
                    </span>
                  </div>
                }
                name="mobile"
                required={false}
                className=""
              >
                <PhoneInputWithCountrySelect
                  defaultCountry="SA"
                  value={value2}
                  onChange={setValue2}
                  limitMaxLength={true}
                  international
                  hasFeedback
                  className="!border-[1px] !border-solid !border-color-primary !py-2 !px-[11px] !h-[42px]"
                />
              </Form.Item>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={isEdit ? loadingUpdate : isLoading}
            >
              {isEdit
                ? intl.formatMessage({ id: "updateResourceInfo" })
                : intl.formatMessage({ id: "addSupplierButton" })}
            </Button>
            <Button
              type="primary"
              onClick={() => close()}
              block
              className="btn-primary-light"
            >
              {intl.formatMessage({ id: "cancel" })}
            </Button>
          </div>
        </Form>
      )}
      {/* {isEdit ? (
        <div
          className="flex items-center justify-center mt-6 cursor-pointer text-color-danger"
          onClick={() => DeleteSuppliers(Supplier?.data?.id)}
        >
          {intl.formatMessage({ id: "deleteResource" })}
        </div>
      ) : null} */}
    </div>
  );
};

export default ModalForm;
